<form
    novalidate
    #property3DTourSectionForm="ngForm"
    class="property-3d-tour-section"
    *ngIf="draftLoaded$ | async"
>
    <tg-row>
        <tg-col lg="6" md="12">
            <tg-input-group>
                <tg-input-container
                    label="3D tour URL"
                    showRemainingCharacters="false"
                >
                    <input
                        tgTextInput
                        name="threeDTourUrl"
                        type="text"
                        [(ngModel)]="draftData.propertyPhotos.threeDTourUrl"
                        placeholder="Copy and paste your 3D tour link here"
                        [disabled]="inputDisabled"
                        (input)="onInputChange($event.target.value)"
                    />
                </tg-input-container>
                <button
                    tgButton2
                    class="property-3d-tour-section__add-button"
                    (click)="on3DTourButtonClick()"
                    [tgLoading]="isProcessing"
                    [disabled]="!draftData.propertyPhotos.threeDTourUrl"
                >
                    {{ buttonTitle }}
                </button>
            </tg-input-group>
        </tg-col>
    </tg-row>
    <tg-row *ngIf="hasError">
        <tg-col lg="6" md="12">
            <p class="property-3d-tour-section__validate-fail">
                {{ errorMessage }}
            </p>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" md="12">
            <span class="p-secondary-copy">
                <a
                    class="h-link-no-visited"
                    target="_blank"
                    href="https://help.trademe.co.nz/hc/en-us/articles/4408625673101-Videos-and-3D-tours-on-listings"
                >
                    Check out our handy guide
                </a>
                to adding 3D tour
            </span>
        </tg-col>
    </tg-row>
    <tg-row *ngIf="previewUrl" class="property-3d-tour-section__preview">
        <tg-col lg="6" md="12">
            <div class="property-3d-tour-section__tour">
                <iframe
                    width="100%"
                    [src]="safeUrl"
                    title="Preview"
                    frameborder="0"
                    allowfullscreen
                ></iframe>
            </div>
        </tg-col>
    </tg-row>
</form>
